var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/utils/numbers.tsx";
import React from 'react';
import { FormattedNumber } from 'react-intl';

/** Check if a value is REALLY a number. */
export const isNumber = value => typeof value === 'number' && !isNaN(value);

/** Display a number nicely for the UI, eg 1000 becomes 1K. */
export const shortNumberFormat = number => {
  if (!isNumber(number)) return '•';
  if (number < 1000) {
    return /*#__PURE__*/React.createElement(FormattedNumber, {
      value: number,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 12,
        columnNumber: 12
      }
    });
  } else if (number < 1000000) {
    return /*#__PURE__*/React.createElement("span", {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 14,
        columnNumber: 12
      }
    }, /*#__PURE__*/React.createElement(FormattedNumber, {
      value: number / 1000,
      maximumFractionDigits: 1,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 14,
        columnNumber: 18
      }
    }), "K");
  } else {
    return /*#__PURE__*/React.createElement("span", {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 16,
        columnNumber: 12
      }
    }, /*#__PURE__*/React.createElement(FormattedNumber, {
      value: number / 1000000,
      maximumFractionDigits: 1,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 16,
        columnNumber: 18
      }
    }), "M");
  }
};

/** Check if an entity ID is an integer (eg not a FlakeId). */
export const isIntegerId = id => new RegExp(/^-?[0-9]+$/g).test(id);